import { lazy } from 'react';

const AuditLockAdminComponent = lazy(() =>
  import('../pages/AuditLock/AdminAcess'),
);

const auditLockAdminRoute = {
  auth: [
    {
      name: 'audit_lock_admin',
      path: '/audit-lock/admin',
      component: AuditLockAdminComponent,
    },
  ],
};

export default auditLockAdminRoute;
